import { Injectable } from '@angular/core';
import { CanActivate,
  CanActivateChild,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot } from '@angular/router';

import { AuthService } from '../services/auth.service';

 
@Injectable({
  providedIn: 'root'
})

export class AuthGuard implements CanActivate, CanActivateChild {
  

  constructor(
    public auth: AuthService,
    public router: Router
  ){}
  
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
    ): boolean  {

      let loggedInUser = this.auth.getUser();


    if (this.auth.isAuthenticated()) {

                return true
    } else {
    this.router.navigate(['sign-in']);
    return false
  }

  
}    


canActivateChild(
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean {

  let loggedInUser = this.auth.getUser();

    if (loggedInUser.rol === 'admin'|| loggedInUser.rol === 'user' ) {

      
      return true;

        } else {

    //console.log("Unauthorized to open link");
	alert("Necesita ser administrador para acceder a esta función.")
    return false;

  }


}
  
}
 